module.exports = __webpack_public_path__ + "media/metronic/_theme/media/files/css-9c9c21e82f7cca1404006ede8add5ecb.svg";